export const environment = {
  production: true,
  // apiRoot:'https://localhost:53114'
   // apiRoot:'https://localhost:53114'
    //apiRoot:'https://172.16.0.190:4433'
   // apiRoot:'https://asmaback.pioneers-solutions.info'
  //apiRoot:'https://etiback.etigroup-eg.org'

     //apiRoot:'https://pioback.pioneers-solutions.info'
    //apiRoot:'https://honestbak.pioneers-solutions.info'
     //apiRoot:'https://tectestback.pioneers-solutions.info'
    //apiRoot:'https://honestbak.pioneers-solutions.info'
   // apiRoot:'https://honestbak.pioneers-solutions.info'
    // apiRoot:'https://elrabwabak.pioneers-solutions.info'
      //apiRoot:'http://172.16.0.13:8092'
      //apiRoot:'https://172.16.0.13:8094'
      
   //apiRoot:'https://etiback.etigroup-eg.org'
     //apiRoot:'https://erpback.pioneers-solutions.info'
    //apiRoot:'http://192.168.1.7:5825'
   //apiRoot:'https://172.16.0.190'
 //apiRoot: 'http://172.16.0.13:4500'
  // apiRoot: 'http://172.16.0.44:44389'
//apiRoot:'https://erpback.pioneers-solutions.info'
  // apiRoot: 'https://172.16.0.13:8090'
  //  apiRoot: 'https://172.16.0.13'
  
 
      // apiRoot: 'https://elrabwabak.pioneers-solutions.info'
           // apiRoot:'https://erpback2.pioneers-solutions.info'
 // apiRoot: 'https://cdcbak.pioneers-solutions.info'
     //apiRoot:'https://ingazbak.pioneers-solutions.info'
     // apiRoot:'https://Karma-toysback.pioneers-solutions.info'
    //apiRoot: 'https://cdcbak.pioneers-solutions.info'
    apiRoot: 'https://pioback.pioneers-solutions.info'
  //apiRoot: 'https://cdcbak.pioneers-solutions.info'
   //apiRoot: 'https://cdcbak.pioneers-solutions.info'
      //   apiRoot: 'https://elrabwabak.pioneers-solutions.info'
          //  apiRoot:'https://tectestback.pioneers-solutions.info'
 //apiRoot: 'https://shahinback.pioneers-solutions.info'
  //  //  apiRoot: 'https://tectestback.pioneers-solutions.info'
 // apiRoot: 'https://gizahmsback.pioneers-solutions.com'      


      // apiRoot:'https://erpback.pioneers-solutions.info' 

  //    apiRoot:'https://erpback.pioneers-solutions.info' 



     // apiRoot:'https://erpback.pioneers-solutions.info' 

     // apiRoot:'https://erpback.pioneers-solutions.info' 


};
